const workshops = [
  {
    name: 'نجات پرابلیوس',
    image: '/eht.JPG',
    description: [
      'احتمالاً الان رو به روی مانیتور و یا گوشیتون نشسته باشید؛ منتظر باشید که ببینید توی این متن قراره راجع به چه چیزی حرف بزنیم... درست می‌گم؟',
      'اگه دقت کرده باشید من از واژه‌ی "احتمال" استفاده کردم. بیاید یکم دقیق تر بهش فکرکنیم.',
      'کلمه‌ای که روزمره به طور آشکار ازش استفاده می‌کنیم اما به عنوان یه مفهوم ذهنی می‌شناسیمش. اما آیا احتمال صرفا یه مفهوم ذهنیه؟!',
      'به نظر شما امکانش هست که با استفاده از یک سری نتایج احتمالی توی دنیای واقعی کار بزرگی انجام بدیم؟',
      'اگه داده‌های احتمالی رو جعبه‌ی ابزار، و خودمون رو یه مکانیک در نظر بگیریم، چه‌طور می‌تونیم از این ابزار در جهت تحقق اهدافمون استفاده کنیم؟',
      'تو این کارگاه قصد داریم با هم دیگه راجع به یکی از مسائلی که امروزه باهاش درگیر هستیم صحبت کنیم و ببینیم که در پشت پرده اخباری که بهمون می‌ده، از چه چیزهایی استفاده می‌شه...',
      'راستی احتمال یه رفیق شفیق هم داره که خیلی خوب میشناسدش و توی بروز دادن افکارش همیشه کمکش میکنه!',
      'پس با ما همراه باشید تا ببینیم دقیقا چه خبره...',
    ],
    teaserLink: 'https://www.aparat.com/video/video/embed/videohash/OBoKE/vt/frame'
  },
  {
    name: 'اپتیکالیپتوس نامرئی',
    image: '/opt.JPG',
    description: [
      'تا به حال به دنياي تاريك و بدون نور فكر كردين؟چقدر تنهاتر ميشديم اگه همديگه رو يا حتی اطرافمون رو نمی‌ديديم!',
      'انگاری اين نوری كه از خورشيد به سمت‌مون مياد بزرگترين رسالتش ايجاد گرما و صميمت به واسطه‌ی ممکن‌کردنِ ديدن بين ما آدما و به طور كل موجوداته، نه؟',
      'ميدونستين "شكست" هميشه هم بد و ناراحت‌كننده نيست! اگه به سفر يه پرتو نور كه از خورشيد جدا ميشه تا به چشم ما برسه نگاه كنيد می‌بينيد كه توی اين مسير مجبوره كلي شكست بخوره!',
      'اون ميشكنه تا ما اين دنيارو قشنگ‌تر ببينيم...',
      'اگه دوست‌دارين از زندگی شخصی يک پرتو نور سر دربيارين و زيبایی‌های دنيای رنگی‌رنگی رو بيشتر بشناسين، كارگاه اپتیکالیپتوس نامرئی رو از دست ندين!',
    ],
    teaserLink: 'https://www.aparat.com/video/video/embed/videohash/5ajz6/vt/frame'
  },
  {
    name: 'بحران در آکادمی',
    image: '/hend.JPG',
    description: [
      'صدای ما رو از آتن، قلب یونان می‌شنوید. جایی که روزگاری تعالیم افلاطون رو روی چشمشون میذاشتن، اما حالا... هعی. حالا همه جا صحبت از معادله‌ها و عبارات ریاضیاتی‌ هست که کاملا غلطن، اما شهر پر از افرادی شده که با انجام یک سری استدلال، می‌تونن درستی اون گزاره‌های غلط رو ثابت کنن! ',
      'ما در این کارگاه قصد داریم در کنار هم دیگه یاد بگیریم که چه‌طوری می‌تونیم استدلال کنیم و با انجام چه مراحلی میتونیم درستی یا نادرستی عبارات مختلف به خصوص در فضای هندسه رو ثابت کنیم. اگر دوست دارین بدونید که این روابط هندسی و مسیرهای استدلالی چطور شهر آتن رو نجات میدن وچه کاربردهای دیگری دارن، کارگاه ما رو از دست ندین!',
    ],
    teaserLink: 'https://www.aparat.com/video/video/embed/videohash/9ngSy/vt/frame'
  },
]

export default workshops;